import React, { useEffect, useState } from 'react'
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { message, ConfigProvider, App } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import zh_CN from 'antd/locale/zh_CN'
import en_US from 'antd/locale/en_US'
import { setLanguageObj } from './redux/actions/commonActions'

import LoginLayout from './pages/layout/LoginLayout'
import MainLayout from './pages/layout/MainLayout'
// import store from './redux'
import { languageObj } from './utils/common'
import { defaultToken } from '@/utils/default'
import './App.less'
import 'animate.css'
message.config({
  top: 10,
  duration: 3,
  maxCount: 1
})

const AppPage = () => {
  const dispatch = useDispatch()
  const [locale, setLocal] = useState({})
  const [themeObj, setThemeObj] = useState({ fontSize: 13, controlHeight: 32 })
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const languageState = useSelector(state => state.commonStore.language)
  // store.subscribe(() => {
  //   const state = store.getState()
  //   const language = state.commonStore.language
  //   if (language === 'zh_CN') {
  //     dayjs.locale('zh-cn')
  //     setLocal(zh_CN)
  //   }
  //   if (language === 'en_US') {
  //     dayjs.locale('en')
  //     setLocal(en_US)
  //   }
  // })
  useEffect(() => {
    if (languageState === 'zh_CN') {
      dayjs.locale('zh-cn')
      setLocal(zh_CN)
      dispatch(setLanguageObj(languageObj['zh_CN']))
    }
    if (languageState === 'en_US') {
      dayjs.locale('en')
      setLocal(en_US)
      dispatch(setLanguageObj(languageObj['en_US']))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])

  useEffect(() => {
    setThemeObj({ fontSize: 13 * deviceSize, controlHeight: 32 * deviceSize })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSize])
  useEffect(() => {
    dispatch(setLanguageObj(languageObj[languageState]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale])
  return (
    <div id="container">
      <ConfigProvider
        locale={locale}
        theme={{
          token: {
            // // type='primary'时的背景色
            colorText: '#777796',
            colorTextHeading: '#777796',
            colorInfo: '#f29950',
            colorLink: '#f29950',
            colorPrimary: '#f29950',
            // // 主色浅色背景颜色，一般用于视觉层级较弱的选中状态: 如table-select
            // colorPrimaryBg: '#e6f4ff',
            // colorPrimaryBgHover: '#bae0ff',
            // // 鼠标浮上去的颜色
            // colorPrimaryHover: '#111',
            // // 点击时的颜色
            // colorPrimaryActive: '#111',
            ...themeObj
          },
          components: {
            Menu: {
              darkItemColor: '#777796',
              // 选中菜单文字颜色
              darkItemSelectedColor: '#f29950',
              // 鼠标浮上去颜色
              darkItemHoverColor: '#f29950',
              // 选中菜单背景色
              // rgba(242 153 80, 0.2)
              darkItemSelectedBg: '#f2995033',
              // 背景色
              darkItemBg: '#f0e9e9',
              // 二级菜单背景色
              darkSubMenuItemBg: '#f0e9e9'
            },
            Layout: {
              // 背景色
              siderBg: '#f0e9e9'
            },
            Form: {
              labelColor: '#f29950'
            },
            Card: {
              bodyPadding: 20
            }
          }
        }}
      >
        <App>
          <Switch>
            <Route
              path="/login"
              render={() => {
                if (Cookies.get(defaultToken)) {
                  let pt = '/'
                  return <Redirect to={pt} />
                } else {
                  return <LoginLayout />
                }
              }}
            />
            <Route path="/" component={MainLayout} />
          </Switch>
        </App>
      </ConfigProvider>
    </div>
  )
}

export default withRouter(AppPage)
